module.exports = __webpack_public_path__ + "static/img/guanbihuiyi.43a6ad4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/guanbihuiyi.png
// module id = 0sG3
// module chunks = 24